import { FilterGroup, InboxDropdownFilterType, ModeType, StateParams } from "@app2/fraud/type-defs";
import { DropdownOption } from "@app2/shared/predicate-dropdown-menu.component";

export const fraudAlertGroups: FilterGroup[] = [
    {
        name: "ACTIVE",
        filters: [
            { key: "NEW", icon: "far fa-fw fa-circle" },
            { key: "ACKED", icon: "fas fa-fw fa-check" },
        ],
    }, {
        name: "HANDLED",
        filters: [
            { key: "ESCALATED", icon: "fas fa-fw fa-triangle-exclamation" },
            // We use a custom SVG for the fraud flag icon
            { key: "FRAUD_FLAGGED", icon: undefined },
            { key: "DISMISSED", icon: "fas fa-fw fa-xmark" },
        ],
    },
];

export const securityAlertGroups: FilterGroup[] = [
    {
        name: "ACTIVE",
        filters: [
            { key: "NEW", icon: "far fa-fw fa-circle" },
            { key: "ACKED", icon: "fas fa-fw fa-check" },
        ],
    }, {
        name: "HANDLED",
        filters: [
            { key: "ESCALATED", icon: "fas fa-fw fa-triangle-exclamation" },
            { key: "DISMISSED", icon: "fas fa-fw fa-xmark" },
        ],
    },
];

export const fraudModeOptions: DropdownOption<ModeType>[] = [
    {
        key: "TRIGGER_VIEW",
        value: "trigger",
    },
    {
        key: "ALERT_VIEW",
        value: "alert",
    },
    {
        key: "ALERT_STORY_VIEW",
        value: "alert_story",
    },
];

export const fraudDropdownFilterOptions: DropdownOption<InboxDropdownFilterType>[] = [
    {
        key: "ALL",
        value: "all",
    },
    {
        key: "TRAC",
        value: "true",
    },
    {
        key: "CLIENT",
        value: "false",
    },
    {
        key: "INFORMATIONAL",
        value: "informational",
    }
];

export const initialStateParams: StateParams = {
    mode: "trigger",
    dropdownFilter: "all",
    sort: "newest_first",
    state: "NEW",
    page: "1",
};

interface RiskFactorConstant {
    titleKey: string,
    description: string,
}

export const UBA_RISK_FACTORS: RiskFactorConstant[] = [
    {
        titleKey: "UBA_RISK_FACTOR_NEW_DEVICE",
        description: "An account was accessed with a device not used by this person before.",
    }, {
        titleKey: "UBA_RISK_FACTOR_NEW_OS",
        description: "An account was accessed with an operating system not used by this person before.",
    }, {
        titleKey: "UBA_RISK_FACTOR_NEW_BROWSER",
        description: "An account was accessed with a browser not used by this person before.",
    }, {
        titleKey: "UBA_RISK_FACTOR_NEW_CITY",
        description: "An account was accessed from a city this person has not logged in from before.",
    }, {
        titleKey: "UBA_RISK_FACTOR_NEW_STATE",
        description: "An account was accessed from a state this person has not logged in from before.",
    }, {
        titleKey: "UBA_RISK_FACTOR_HOUR_OF_DAY",
        description: "An account was accessed at a time of day that is unusual for this person.",
    }, {
        titleKey: "UBA_RISK_FACTOR_IMPROBABLE_TRAVEL",
        description: "An account was accessed from two locations in a short period of time where it would not have " +
                     "been possible for the person to travel between them.",
    }, {
        titleKey: "UBA_RISK_FACTOR_PASSWORD_CHANGED",
        description: "The person’s password was changed.",
    }, {
        titleKey: "UBA_RISK_FACTOR_NEW_EMAIL_ADDED",
        description: "The person’s email address was changed.",
    }, {
        titleKey:"UBA_RISK_FACTOR_NEW_EMAIL_ATTEMPT",
        description:"There was an attempt to change the person's email address."
    }, {
        titleKey: "UBA_RISK_FACTOR_NEW_PHONE_ADDED",
        description: "The person’s phone number was changed.",
    }
];

export const FRAUD_IMPORTANT_FIELDS = [
    "ip_src",
    "client_ip",
    "user",
    "user_name",
    "finxact_id",
    "username",
    "user_agent",
    "browser",
    "email_address",
    "email_addresses",
    "action_taken_details",
    "phone_number",
    "phone_numbers",
    "request_url",
    "account_number",
    "txn_dest_account_number",
    "txn_orig_account_number",
    "client_asn",
];
